const Name = ({ name }) => {
	return <span className="name">{name}</span>
}

export default Name
